import React from 'react';

/**
 * Neutral placeholder shown while a page's code chunk is still loading.
 * It only sketches the shared frame (title band + a soft content area) so no
 * page is shown a foreign layout such as the activity card grid.
 */
export default function PageSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50" aria-hidden="true">
      <section className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="h-8 w-56 max-w-full rounded shimmer" />
          <div className="h-4 w-80 max-w-full rounded shimmer mt-3" />
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="h-56 rounded-2xl shimmer" />
      </div>
    </div>
  );
}